// extracted by mini-css-extract-plugin
export var antFormItemHasError = "CustomInput-module--ant-form-item-has-error--9b9c2";
export var antInput = "CustomInput-module--ant-input--71847";
export var antInputDisabled = "CustomInput-module--ant-input-disabled--54a39";
export var customInputBox = "CustomInput-module--customInputBox--d95dd";
export var customInputWrapper = "CustomInput-module--customInputWrapper--06920";
export var error = "CustomInput-module--error--60051";
export var extraLabelRight = "CustomInput-module--extraLabelRight--b9a26";
export var inputDisabledLabel = "CustomInput-module--inputDisabledLabel--e391d";
export var inputLabel = "CustomInput-module--inputLabel--87195";
export var lmsScrollbar = "CustomInput-module--lms-scrollbar--8d3e3";
export var optionalLabel = "CustomInput-module--optionalLabel--f0a81";